import ToastPopup from '../../../HelperClasses/AppLoaderClasses/ToastPopup';

export const checkSubscriptionForm = ({form_data, t = (key, fallback) => fallback}) => {
  if (
    form_data?.title === '' ||
    form_data?.title?.replace(/\s/g, '').length <= 0
  ) {
    ToastPopup({type: 'error', message: t('subscriptions.validation.title_required', 'Title is required')});
    return false;
  }

  if (form_data?.allowed_listings === '' || form_data?.allowed_listings <= 0) {
    ToastPopup({
      type: 'error',
      message: t('subscriptions.validation.allowed_listings_positive', 'Allowed listings should be greater than 0'),
    });
    return false;
  }

  if (form_data?.currency_id === '' || form_data?.currency_id === null) {
    ToastPopup({type: 'error', message: t('subscriptions.validation.currency_required', 'Currency is required')});
    return false;
  }
  if (form_data?.expiry_days === '' || form_data?.expiry_days <= 0) {
    ToastPopup({type: 'error', message: t('subscriptions.validation.expiry_required', 'Expiry days are required')});
    return false;
  }
  if (
    form_data?.type === '' ||
    form_data?.type?.replace(/\s/g, '').length <= 0
  ) {
    ToastPopup({type: 'error', message: t('subscriptions.validation.payment_method_required', 'Payment method is required')});
    return false;
  }

  return true;
};
